<!--  Created by   : ANKUSH BHARDWAJ                                                           -->
<!--  Create Dated : 22-NOV-2021                                                              -->
<!--  Purpose      : Master Entry                                                             -->
<template>
  <div id="divMasterEnrty">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Master Type &nbsp;
          </span>
          <select
            id="ddlMasterType"
            @change="getPageLoad()"
            v-model="masterTypeID"
          >
            <option value="-1">---Select---</option>
            <option
              v-for="c in masterType_List"
              :key="c[0]"
              v-bind:value="c[0]"
            >
              {{ c[1] }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell" style="width: 85%"></div>
      </div>
    </div>
    <div class="Flex_Table tblEntryForm" id="divTitle" v-if="masterTypeID == 1">
      <div class="Flex_Row">
        <div class="Flex_Cell" style="display: none">
          <span>Title Id</span>
          <AcceptInput
            maxlength="10"
            ref="titleId"
            type="label"
            placeholder="PLEASE ENTER TITLE ID"
            v-model="titleId"
            class="CreateAccount"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Title Name</span
          >
          <AcceptInput
            maxlength="20"
            ref="titleName"
            type="textbox"
            placeholder="PLEASE ENTER TITLE NAME"
            v-model="titleName"
            class="CreateAccount"
            regExp="([A-Z ' .'a-z])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">Order</span>
          <AcceptInput
            maxlength="3"
            ref="seniority"
            type="textbox"
            placeholder="PLEASE ENTER ORDER"
            v-model="seniority"
            class="CreateAccount"
            regExp="([0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Active &nbsp;
          </span>
          <select id="ddlIsActive" v-model="activeStatus">
            <option
              v-for="a in activeStatus_List"
              :key="a.activeStatus"
              v-bind:value="a.activeStatus"
            >
              {{ a.activeStatusName }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="padding-bottom: 10px; padding-top: 10px">
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell" style="text-align: right">
          <input
            type="button"
            style="padding: 5px"
            title="Click to Save Title"
            v-model="saveTitle"
            @click="setTitle()"
          />
        </div>
        <div class="Flex_Cell" style="text-align: left">
          <input
            type="button"
            v-model="Clear"
            style="padding: 5px"
            title="Click to Clear"
            @click="clearTitle()"
          />
        </div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="width: 80%">
        <div class="Flex_Table ekkGrid" style="border-radius: 6px">
          <div
            class="Flex_Row GridHeader"
            valign="middle"
            style="min-height: 40px"
          >
            <div class="Flex_Cell" style="min-height: 33%; display: none">
              Title Id
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Sr. No.
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 35%"
            >
              Title Name
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 15%"
            >
              Order
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 20%"
            >
              Active Status
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Edit
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Delete
            </div>
          </div>
          <div
            class="Flex_Row"
            v-for="(row, index) in title_List"
            :key="index"
            style="min-height: 30px"
          >
            <div class="Flex_Cell" style="display: none" align="center">
              {{ row[0] }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <b>{{ index + 1 }}</b>
            </div>
            <div class="Flex_Cell" style="width: 35%" align="center">
              {{ row[1] }}
            </div>
            <div class="Flex_Cell" style="width: 15%" align="center">
              {{ row[3] }}
            </div>
            <div class="Flex_Cell" style="width: 20%" align="center">
              <span v-if="row[4] == 1" style="color: green">Yes</span>
              <span v-else style="color: red">No</span>
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <span
                class="glyphicons pen"
                v-on:click="editTitle(row)"
                style="cursor: pointer"
                title="Edit"
              ></span>
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <span
                class="glyphicons bin"
                v-on:click="deleteTitle(row)"
                style="cursor: pointer"
                title="Delete"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="Flex_Table tblEntryForm"
      id="divUserType"
      v-if="masterTypeID == 2"
    >
      <div class="Flex_Row">
        <div class="Flex_Cell" style="display: none">
          <span>User Type Id</span>
          <AcceptInput
            maxlength="20"
            ref="userTypeID"
            type="label"
            placeholder="PLEASE ENTER USER TYPE ID"
            v-model="userTypeID"
            class="CreateAccount"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >User Type</span
          >
          <AcceptInput
            maxlength="50"
            ref="userType"
            type="textbox"
            placeholder="PLEASE ENTER USER TYPE"
            v-model="userType"
            class="CreateAccount"
            regExp="([A-Z ' ,-/&@*()'a-z0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Active &nbsp;
          </span>
          <select id="ddlIsActive" v-model="activeStatus">
            <option
              v-for="a in activeStatus_List"
              :key="a.activeStatus"
              v-bind:value="a.activeStatus"
            >
              {{ a.activeStatusName }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="padding-bottom: 10px; padding-top: 10px">
        <div class="Flex_Cell" style="text-align: right">
          <input
            type="button"
            v-model="saveUserType"
            style="padding: 5px"
            title="Click to Save User Type"
            @click="setUserType()"
          />
        </div>
        <div class="Flex_Cell" style="text-align: left">
          <input
            type="button"
            v-model="Clear"
            style="padding: 5px"
            title="Click to Clear"
            @click="clearUserType()"
          />
        </div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="width: 50%">
        <div class="Flex_Table ekkGrid" style="border-radius: 6px">
          <div
            class="Flex_Row GridHeader"
            valign="middle"
            style="min-height: 40px"
          >
            <div class="Flex_Cell" style="min-height: 33%; display: none">
              User Type Id
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Sr. No.
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 50%"
            >
              User Type
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 20%"
            >
              Active Status
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Edit
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Delete
            </div>
          </div>
          <div
            class="Flex_Row"
            v-for="(row, index) in userType_List"
            :key="index"
            style="min-height: 30px"
          >
            <div class="Flex_Cell" style="display: none" align="center">
              {{ row[0] }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <b>{{ index + 1 }}</b>
            </div>
            <div class="Flex_Cell" style="width: 50%" align="center">
              {{ row[1] }}
            </div>
            <div class="Flex_Cell" style="width: 20%" align="center">
              <span v-if="row[2] == 1" style="color: green">Yes</span>
              <span v-else style="color: red">No</span>
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <span
                class="glyphicons pen"
                v-on:click="editUserType(row)"
                style="cursor: pointer"
                title="Edit"
              ></span>
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <span
                class="glyphicons bin"
                v-on:click="deleteUserType(row)"
                style="cursor: pointer"
                title="Delete"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="Flex_Table tblEntryForm"
      id="divBookingType"
      v-if="masterTypeID == 3"
    >
      <div class="Flex_Row">
        <div class="Flex_Cell" style="display: none">
          <span>Booking Type Id</span>
          <AcceptInput
            maxlength="10"
            ref="bookingTypeID"
            type="textbox"
            placeholder="PLEASE ENTER BOOKING TYPE ID"
            v-model="bookingTypeID"
            class="CreateAccount"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Booking Type</span
          >
          <AcceptInput
            maxlength="100"
            ref="bookingType"
            type="textbox"
            placeholder="PLEASE ENTER BOOKING TYPE"
            v-model="bookingType"
            class="CreateAccount"
            regExp="([A-Z ' ,-/&@*()'a-z0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Category &nbsp;
          </span>
          <select id="ddlCatType" v-model="catType">
            <option value="-1">---Select---</option>
            <option v-for="c in catType_List" :key="c[0]" v-bind:value="c[0]">
              {{ c[1] }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Duration Value
          </span>
          <AcceptInput
            maxlength="3"
            ref="value"
            type="textbox"
            placeholder="PLEASE ENTER DURATION VALUE"
            v-model="value"
            class="CreateAccount"
            regExp="([0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Duration Unit &nbsp;
          </span>
          <select id="ddlBookingForUnits" v-model="bookingForUnit">
            <option value="-1">---Select---</option>
            <option
              v-for="b in bookingForUnits_List"
              :key="b[0]"
              v-bind:value="b[0]"
            >
              {{ b[1] }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Active &nbsp;
          </span>
          <select id="ddlIsActive" v-model="activeStatus">
            <option
              v-for="a in activeStatus_List"
              :key="a.activeStatus"
              v-bind:value="a.activeStatus"
            >
              {{ a.activeStatusName }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell">
          <br />
          <span class="mandatorySpan" :class="{ Required: true }"
            ><input id="isGroup" type="checkbox" value="1" name="isGroup" />
            <label for="isGroup" class="lblClass">Is Group</label>
          </span>
        </div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="padding-bottom: 10px; padding-top: 10px">
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell" style="text-align: right">
          <input
            type="button"
            v-model="saveBookingType"
            style="padding: 5px"
            title="Click to Save Booking Type"
            @click="setBookingType()"
          />
        </div>
        <div class="Flex_Cell" style="text-align: left">
          <input
            type="button"
            v-model="Clear"
            style="padding: 5px"
            title="Click to Clear"
            @click="clearBookingType()"
          />
        </div>
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell"></div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="width: 100%">
        <div class="Flex_Table ekkGrid" style="border-radius: 6px">
          <div
            class="Flex_Row GridHeader"
            valign="middle"
            style="min-height: 40px"
          >
            <div class="Flex_Cell" style="min-height: 10%; display: none">
              Booking Type Id
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Sr. No.
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 30%"
            >
              Booking Type
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Is Group
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Category
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 15%"
            >
              Duration
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 15%"
            >
              Active Status
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 5%"
            >
              Edit
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 5%"
            >
              Delete
            </div>
          </div>
          <div
            class="Flex_Row"
            v-for="(row, index) in bookingType_List"
            :key="index"
            style="min-height: 30px"
          >
            <div class="Flex_Cell" style="display: none" align="center">
              {{ row.bookingTypeID }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <b>{{ index + 1 }}</b>
            </div>
            <div class="Flex_Cell" style="width: 30%" align="center">
              {{ row.bookingTypeNamePlain }}
            </div>
            <div class="Flex_Cell" style="display: none" align="center">
              {{ row.bookingForUnitsID }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <span v-if="row.isForGroup == 1">Yes</span>
              <span v-else>No</span>
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              {{ row.typeCatName }}
            </div>
            <div class="Flex_Cell" style="width: 15%" align="center">
              <span>{{ row.bookingForValue }}</span
              >&nbsp; <span>{{ row.bookingForUnitsName }}</span>
            </div>
            <div class="Flex_Cell" style="width: 15%" align="center">
              <span v-if="row.isActive == 1" style="color: green">Yes</span>
              <span v-else style="color: red">No</span>
            </div>
            <div class="Flex_Cell" style="width: 5%" align="center">
              <span
                class="glyphicons pen"
                v-on:click="editBookingType(row)"
                style="cursor: pointer"
                title="Edit"
              ></span>
            </div>
            <div class="Flex_Cell" style="width: 5%" align="center">
              <span
                class="glyphicons bin"
                v-on:click="deleteBookingType(row)"
                style="cursor: pointer"
                title="Delete"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="Flex_Table tblEntryForm"
      id="divAgeGroup"
      v-if="masterTypeID == 4"
    >
      <div class="Flex_Row">
        <div class="Flex_Cell" style="display: none">
          <AcceptInput
            maxlength="100"
            ref="groupNameID"
            type="textbox"
            placeholder="PLEASE ENTER GROUP ID"
            v-model="groupNameID"
            class="CreateAccount"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Booking Type &nbsp;
          </span>
          <select
            id="ddlAgeGroupType"
            @change="getPersonAgeGroup()"
            v-model="ageGroupType"
          >
            <option value="-1">---Select---</option>
            <option
              v-for="ag in ageGroupType_List"
              :key="ag[0]"
              v-bind:value="ag[0]"
            >
              {{ ag[1] }}
            </option>
          </select>
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Group Name</span
          >
          <AcceptInput
            maxlength="100"
            ref="groupName"
            type="textbox"
            placeholder="PLEASE ENTER GROUP NAME"
            v-model="groupName"
            class="CreateAccount"
            regExp="([A-Z ' ,-/&@*()'a-z0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >No. of Individuals</span
          >
          <AcceptInput
            maxlength="4"
            ref="noOfIndividuals"
            type="textbox"
            id="noOfIndi"
            placeholder="PLEASE ENTER NO. OF INDIVIDUALS"
            v-model="noOfIndividuals"
            class="CreateAccount"
            regExp="([0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Amount (In Rupees)</span
          >
          <AcceptInput
            maxlength="10"
            ref="amount"
            type="textbox"
            placeholder="PLEASE ENTER AMOUNT (IN RUPEE)"
            v-model="amount"
            class="CreateAccount"
            regExp="([0-9])*"
          />
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }"
            >Effective From</span
          >
          <DateControl
            :isRequired="true"
            style="max-width: 295px !important"
            v-model="withEffectiveFrom"
          ></DateControl>
        </div>
        <div class="Flex_Cell">
          <span class="mandatorySpan" :class="{ Required: true }">
            Active &nbsp;
          </span>
          <select id="ddlIsActive" v-model="activeStatus">
            <option
              v-for="a in activeStatus_List"
              :key="a.activeStatus"
              v-bind:value="a.activeStatus"
            >
              {{ a.activeStatusName }}
            </option>
          </select>
        </div>
      </div>
      <div class="Fles_Row"></div>
      <div class="Flex_Row" style="padding-bottom: 10px; padding-top: 10px">
        <div class="Flex_Cell"></div>
        <div class="Flex_Cell" style="text-align: right">
          <input
            type="button"
            v-model="saveAgeGroup"
            style="padding: 5px"
            title="Click to Save Age Group"
            @click="setPersonAgeGroup()"
          />
        </div>
        <div class="Flex_Cell" style="text-align: left">
          <input
            type="button"
            v-model="Clear"
            style="padding: 5px"
            title="Click to Clear"
            @click="clearAgeGroup()"
          />
        </div>
        <div class="Flex_Cell"></div>
      </div>

      <div class="Flex_Row" style="width: 100%">
        <div class="Flex_Table ekkGrid" style="border-radius: 6px">
          <div
            class="Flex_Row GridHeader"
            valign="middle"
            style="min-height: 40px"
          >
            <div class="Flex_Cell" style="min-height: 10%; display: none">
              Group Id
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 5%"
            >
              Sr. No.
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 20%"
            >
              Booking Type
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 20%"
            >
              Group Name
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 15%"
            >
              No. of Individuals
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Amount (In Rupees)
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Effective From
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 10%"
            >
              Active Status
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 5%"
            >
              Edit
            </div>
            <div
              class="Flex_Cell"
              align="center"
              valign="middle"
              style="width: 5%"
            >
              Delete
            </div>
          </div>
          <div
            class="Flex_Row"
            v-for="(row, index) in ageGroup_List"
            :key="index"
            style="min-height: 30px"
          >
            <div class="Flex_Cell" style="display: none" align="center">
              {{ row[0] }}
            </div>
            <div class="Flex_Cell" style="display: none" align="center">
              {{ row[1] }}
            </div>
            <div class="Flex_Cell" style="width: 5%" align="center">
              <b>{{ index + 1 }}</b>
            </div>
            <div class="Flex_Cell" style="width: 20%" align="center">
              {{ row[2] }}
            </div>
            <div class="Flex_Cell" style="width: 20%" align="center">
              {{ row[3] }}
            </div>
            <div class="Flex_Cell" style="width: 15%" align="center">
              {{ row[4] }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              {{ row[5] }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              {{ row[6] }}
            </div>
            <div class="Flex_Cell" style="width: 10%" align="center">
              <span v-if="row[7] == 1" style="color: green">Yes</span>
              <span v-else style="color: red">No</span>
            </div>
            <div class="Flex_Cell" style="width: 5%" align="center">
              <span
                class="glyphicons pen"
                v-on:click="editAgeGroup(row)"
                style="cursor: pointer"
                title="Edit"
              ></span>
            </div>
            <div class="Flex_Cell" style="width: 5%" align="center">
              <span
                class="glyphicons bin"
                v-on:click="deleteAgeGroup(row)"
                style="cursor: pointer"
                title="Delete"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import MasterEntry from "./servicesJS/MasterEntry";
import Master from "./servicesJS/Master";

export default {
  name: "MasterEntry",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl,
  },
  data() {
    return {
      masterTypeID: -1,
      masterType_List: [],

      divTitle: false,
      titleName: "",
      titleId: -1,
      seniority: "",
      titleShortName: "",
      title_List: [],
      saveTitle: "Save Title",

      divUserType: false,
      userType: "",
      userTypeID: -1,
      userTypeName: "",
      userType_List: [],
      saveUserType: "Save User Type",

      divBookingType: false,
      bookingForUnitsID: -1,
      bookingTypeID: -1,
      bookingType: "",
      bookingForUnit: -1,
      isGroup: 0,
      catType: -1,
      value: "",
      bookingForUnits_List: [],
      bookingType_List: [],
      catType_List: [],
      saveBookingType: "Save Booking Type",

      divAgeGroup: false,
      ageGroupType: -1,
      groupNameID: -1,
      ageGroup_List: [],
      ageGroupType_List: [],
      saveAgeGroup: "Save Age Group",
      noOfIndividuals: "",
      withEffectiveFrom: "01 Jan 1900",
      groupName: "",
      amount: "",
      groupOrNot: -1,

      activeStatus_List: [],
      activeStatus: 1,
      Clear: "Clear",
      type: 1,
    };
  },
  methods: {
    getMasterTypeEntry() {
      this.masterType_List = [];
      const _data_ = {};
      MasterEntry.getMasterType(_data_).then(
        (response) => {
          this.masterType_List = response.data;
          if (response.data.length > 0) {
            this.masterTypeID = -1;
            this.getPageLoad();
          }
        },
        (error) => {}
      );
    },
    getActiveStatus() {
      this.activeStatus_List = [];
      const _data_ = {};
      Master.getActiveStatus(_data_).then(
        (response) => {
          this.activeStatus_List = response.data;
          if (response.data.length > 0) {
            this.activeStatus = 1;
            this.getCatType();
            this.getPersonAgeGroupType();
            //console.log(response.data);
          }
        },
        (error) => {}
      );
    },
    getCatType() {
      this.catType_List = [];
      const _data_ = {};
      Master.getCatType(_data_).then(
        (response) => {
          this.catType_List = response.data;
          if (response.data.length > 0) {
            this.catType = -1;
            this.getBookingForUnits();
            //console.log(response.data);
          }
        },
        (error) => {}
      );
    },
    getTitle() {
      this.title_List = [];
      const _data_ = { rankID: -1, isActive: -1, type: 1 };
      MasterEntry.getRank(_data_).then(
        (response) => {
          this.title_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.title_List);
          }
        },
        (error) => {}
      );
    },
    setTitle() {
      if (this.type == 1) {
        if (this.checkPrams(this.titleName) == true) {
          MessageBox.show({
            message: "Please Type Title Name",
            type: "error",
            title: "API says",
          });
          return;
        }
        // if (this.checkPrams(this.titleShortName) == true) {
        //   MessageBox.show({
        //     message: "Please Type Title Short Name",
        //     type: "error",
        //     title: "API says",
        //   });
        //   return;
        // }
        if (this.checkPrams(this.seniority) == true) {
          MessageBox.show({
            message: "Please Type Seniority",
            type: "error",
            title: "API says",
          });
          return;
        }
      } else {
      }
      var basicData = {
        RankID: this.titleId,
        RankName: this.titleName,
        RankCode: this.titleName,
        Seniority: this.seniority,
        IsActive: this.activeStatus,
        Type: this.type,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      MasterEntry.setRank(formData).then(
        (response) => {
          var msg = "";
          var isSuccess = response.data[0][1];
          if (isSuccess == "True") {
            if (this.saveTitle == "Update Title") {
              msg = "Title updated successfully...";
            } else {
              if (this.type == 2) {
                msg = "Title removed successfully...";
              } else {
                msg = "Title saved successfully...";
              }
            }
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success",
            });
          } else {
            MessageBox.show({
              message: response.data[0][0],
              type: "error",
              title: "Error",
            });
          }
          this.clearTitle();
        },
        (error) => {}
      );
    },
    editTitle(result) {
      this.titleId = result[0];
      this.titleName = result[1];
      this.titleShortName = result[2];
      this.seniority = result[3];
      this.activeStatus = result[4];
      this.saveTitle = "Update Title";
      this.type = 1;
    },
    clearTitle() {
      this.titleId = -1;
      this.titleName = "";
      this.titleShortName = "";
      this.seniority = "";
      this.activeStatus = 1;
      this.saveTitle = "Save Title";
      this.type = 1;
      this.getTitle();
    },
    deleteTitle(result) {
      this.titleId = result[0];
      this.titleName = result[1];
      this.titleShortName = result[2];
      this.seniority = result[3];
      this.activeStatus = result[4];
      this.type = 2;
      if (confirm("Do you want to delete the selected Title?")) {
        this.setTitle();
      } else {
        this.clearTitle();
      }
    },
    getUserType() {
      this.userType_List = [];
      const _data_ = { isActive: -1, type: 2 };
      MasterEntry.getUserType(_data_).then(
        (response) => {
          this.userType_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.userType_List);
          }
        },
        (error) => {}
      );
    },
    setUserType() {
      if (this.type == 1) {
        if (this.checkPrams(this.userType) == true) {
          MessageBox.show({
            message: "Please Type User Type",
            type: "error",
            title: "API says",
          });
          return;
        }
      } else {
      }
      var basicData = {
        userTypeID: this.userTypeID,
        userTypeName: this.userType,
        IsActive: this.activeStatus,
        Type: this.type,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      MasterEntry.setUserType(formData).then(
        (response) => {
          var msg = "";
          var isSuccess = response.data[0][1];
          if (isSuccess == "True") {
            if (this.saveUserType == "Update User Type") {
              msg = "User Type updated successfully...";
            } else {
              if (this.type == 2) {
                msg = "User Type removed successfully...";
              } else {
                msg = "User Type saved successfully...";
              }
            }
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success",
            });
          } else {
            MessageBox.show({
              message: response.data[0][0],
              type: "error",
              title: "Error",
            });
          }
          this.clearUserType();
        },
        (error) => {}
      );
    },
    editUserType(result) {
      this.type = 1;
      this.userTypeID = result[0];
      this.userType = result[1];
      this.activeStatus = result[2];
      this.saveUserType = "Update User Type";
    },
    clearUserType() {
      this.userTypeID = -1;
      this.userType = "";
      this.activeStatus = 1;
      this.saveUserType = "Save User Type";
      this.type = 1;
      this.getUserType();
    },
    deleteUserType(result) {
      this.userTypeID = result[0];
      this.userType = result[1];
      this.activeStatus = result[2];
      this.type = 2;
      if (confirm("Do you want to delete the selected User Type?")) {
        this.setUserType();
      } else {
        this.clearUserType();
      }
    },
    getBookingForUnits() {
      this.bookingForUnits_List = [];
      const _data_ = {};
      MasterEntry.getBookingForUnit(_data_).then(
        (response) => {
          this.bookingForUnits_List = response.data;
          if (response.data.length > 0) {
            this.bookingForUnitsID = -1;
          }
        },
        (error) => {}
      );
    },
    getBookingType() {
      this.bookingType_List = [];
      const _data_ = { isActive: -1, type: 1 };
      MasterEntry.getBookingTypes(_data_).then(
        (response) => {
          this.bookingType_List = response.data;
          if (response.data.length > 0) {
            //console.log(this.bookingType_List);
          }
        },
        (error) => {}
      );
    },
    setBookingType() {
      if (this.type == 1) {
        if (this.checkPrams(this.bookingType) == true) {
          MessageBox.show({
            message: "Please Type Booking Type",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.checkPrams(this.bookingForUnit) == true) {
          MessageBox.show({
            message: "Please Select Duration Unit",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.checkPrams(this.value) == true) {
          MessageBox.show({
            message: "Please Type Duration Value",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.checkPrams(this.catType) == true) {
          MessageBox.show({
            message: "Please Select Category",
            type: "error",
            title: "API says",
          });
          return;
        }
        var isGroup = document.getElementById("isGroup");
        if (isGroup.checked) {
          this.isGroup = 1;
        } else {
          this.isGroup = 0;
        }
      } else {
      }
      var basicData = {
        BookingTypeID: this.bookingTypeID,
        BookingTypeNamePlain: this.bookingType,
        BookingForUnits: this.bookingForUnit,
        IsForGroup: this.isGroup,
        TypeCatID: this.catType,
        BookingForValue: this.value,
        IsActive: this.activeStatus,
        Type: this.type,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      MasterEntry.setBookingType(formData).then(
        (response) => {
          var msg = "";
          var isSuccess = response.data[0][1];
          if (isSuccess == "True") {
            if (this.saveBookingType == "Update Booking Type") {
              msg = "Booking Type updated successfully...";
            } else {
              if (this.type == 2) {
                msg = "Booking Type removed successfully...";
              } else {
                msg = "Booking Type saved successfully...";
              }
            }
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success",
            });
          } else {
            MessageBox.show({
              message: response.data[0][0],
              type: "error",
              title: "Error",
            });
          }
          this.clearBookingType();
        },
        (error) => {}
      );
    },
    clearBookingType() {
      this.bookingTypeID = -1;
      this.bookingType = "";
      this.bookingForUnit = -1;
      this.value = "";
      this.isGroup = 0;
      var isGroup = document.getElementById("isGroup");
      isGroup.checked = false;
      this.catType = -1;
      this.activeStatus = 1;
      this.saveBookingType = "Save Booking Type";
      this.type = 1;
      this.getBookingType();
    },
    editBookingType(result) {
      var isGroup = document.getElementById("isGroup");
      this.bookingTypeID = result.bookingTypeID;
      this.bookingType = result.bookingTypeNamePlain;
      this.bookingForUnit = result.bookingForUnits;
      this.isGroup = result.isForGroup;
      this.catType = result.typeCatID;
      if (this.isGroup == 1) {
        isGroup.checked = true;
      } else {
        isGroup.checked = false;
      }
      this.value = result.bookingForValue;
      this.activeStatus = result.isActive;
      this.saveBookingType = "Update Booking Type";
      this.type = 1;
    },
    deleteBookingType(result) {
      this.bookingTypeID = result.bookingTypeID;
      this.bookingType = result.bookingTypeNamePlain;
      this.isGroup = result.isForGroup;
      this.catType = result.typeCatID;
      this.bookingForUnit = result.bookingForUnits;
      this.value = result.bookingForValue;
      this.activeStatus = result.isActive;
      this.type = 2;
      if (confirm("Do you want to delete the selected Booking Type?")) {
        this.setBookingType();
      } else {
        this.clearBookingType();
      }
    },
    getPersonAgeGroupType() {
      this.ageGroupType_List = [];
      const _data_ = {};
      MasterEntry.getPersonAgeGroupType(_data_).then(
        (response) => {
          this.ageGroupType_List = response.data;
          if (response.data.length > 0) {
            this.ageGroupType = -1;
          }
        },
        (error) => {}
      );
    },
    getPersonAgeGroup() {
      this.ageGroup_List = [];
      // console.log(this.groupOrNot);
      // var g = this.groupOrNot;
      // if (g == 0) {
      //   this.noOfIndividuals = "1";
      // } else {
      //   this.noOfIndividuals = "";
      // }
      const _data_ = {
        personAgeGroupTypeID: this.ageGroupType,
        isActive: -1,
        type: 1,
      };
      MasterEntry.getPersonAgeGroup(_data_).then(
        (response) => {
          this.ageGroup_List = response.data;
          if (response.data.length > 0) {
            var g = this.groupOrNot;
            var n = document.getElementById("noOfIndi");
            if (g == 0) {
              this.noOfIndividuals = "1";
              n.disabled = true;
            } else {
              this.noOfIndividuals = "";
              n.disabled = false;
            }
            //console.log(response);
          }
        },
        (error) => {}
      );
    },
    setPersonAgeGroup() {
      if (this.type == 1) {
        if (this.checkPrams(this.ageGroupType) == true) {
          MessageBox.show({
            message: "Please Select Booking Type",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.checkPrams(this.groupName) == true) {
          MessageBox.show({
            message: "Please Type Group Name",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.checkPrams(this.noOfIndividuals) == true) {
          MessageBox.show({
            message: "Please Type No. of individuals",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.checkPrams(this.withEffectiveFrom) == true) {
          MessageBox.show({
            message: "Please Type Effective From",
            type: "error",
            title: "API says",
          });
          return;
        }
        if (this.amount < 0) {
          MessageBox.show({
            message: "Please Type Amount",
            type: "error",
            title: "API says",
          });
          return;
        }
      } else {
      }
      var basicData = {
        PersonAgeGroupID: this.groupNameID,
        PersonAgeGroupTypeID: this.ageGroupType,
        PersonAgeGroupName: this.groupName,
        NoOfIndividuals: this.noOfIndividuals,
        AmountInRs: this.amount,
        WithEffectiveFrom: this.withEffectiveFrom,
        IsActive: this.activeStatus,
        Type: this.type,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));
      MasterEntry.setPersonAgeGroup(formData).then(
        (response) => {
          var msg = "";
          var isSuccess = response.data[0][1];
          if (isSuccess == "True") {
            if (this.saveAgeGroup == "Update Age Group") {
              msg = "Person Age Group updated successfully...";
            } else {
              if (this.type == 2) {
                msg = "Person Age Group removed successfully...";
              } else {
                msg = "Person Age Group saved successfully...";
              }
            }
            MessageBox.show({
              message: msg,
              type: "success",
              title: "Success",
            });
          } else {
            MessageBox.show({
              message: response.data[0][0],
              type: "error",
              title: "Error",
            });
          }
          this.clearAgeGroup();
        },
        (error) => {}
      );
    },
    editAgeGroup(result) {
      this.groupNameID = result[0];
      this.ageGroupType = result[1];
      this.groupName = result[3];
      this.noOfIndividuals = result[4];
      this.amount = result[5];
      this.withEffectiveFrom = result[6];
      this.activeStatus = result[7];
      this.saveAgeGroup = "Update Age Group";
      this.type = 1;
    },
    clearAgeGroup() {
      this.groupNameID = -1;
      this.ageGroupType = -1;
      this.groupName = "";
      this.noOfIndividuals = "";
      this.amount = "";
      this.withEffectiveFrom = "01 Jan 1900";
      this.activeStatus = 1;
      this.saveAgeGroup = "Save Age Group";
      this.type = 1;
      this.getPersonAgeGroup();
    },
    deleteAgeGroup(result) {
      this.groupNameID = result[0];
      this.ageGroupType = result[1];
      this.groupName = result[3];
      this.noOfIndividuals = result[4];
      this.amount = result[5];
      this.withEffectiveFrom = result[6];
      this.activeStatus = result[7];
      this.type = 2;
      if (confirm("Do you want to delete the selected Age group?")) {
        this.setPersonAgeGroup();
      } else {
        this.clearAgeGroup();
      }
    },
    getPageLoad() {
      this.getActiveStatus();
    },
    checkPrams(_param) {
      var _isError = false;
      if (
        _param == "" ||
        _param == -1 ||
        _param == null ||
        _param == 0 ||
        _param == "01 Jan 1900"
      ) {
        _isError = true;
      }
      if (_isError) {
        return _isError;
      }
    },
  },
  mounted() {
    this.getMasterTypeEntry();
  },
  watch: {
    masterTypeID(newValue, oldValue) {
      if (this.masterTypeID == 1) {
        this.getTitle();
      } else if (this.masterTypeID == 2) {
        this.getUserType();
      } else if (this.masterTypeID == 3) {
        this.getBookingType();
      } else if (this.masterTypeID == 4) {
        this.getPersonAgeGroup();
      }
    },
    ageGroupType(newValue, oldValue) {
      if (this.ageGroupType_List.length > 0) {
        if (this.ageGroupType == -1) {
          this.groupOrNot = -1;
        } else {
          this.groupOrNot = this.ageGroupType_List.filter((a) => {
            return a[0] == this.ageGroupType;
          })[0][2];
        }
      }
    },
  },
};
</script>

<style scoped>
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 150%;
}
#divMasterEnrty {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px; */
}
#divTitle {
  margin-left: 4px;
  margin-right: 5px;
  margin-top: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px;
}
#divUserType {
  margin-left: 4px;
  margin-right: 5px;
  margin-top: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px;
}
#divBookingType {
  margin-left: 4px;
  margin-right: 5px;
  margin-top: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px;
}
#divAgeGroup {
  margin-left: 4px;
  margin-right: 5px;
  margin-top: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 5px 5px;
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .MasterType {
    width: 20%;
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .MasterType {
    width: 50%;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MasterEntry.vue